export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 4_03.b3282a70.jpg";